import React from "react";
import { useTranslation } from "react-i18next";

function PhoneNumberSMSEnable({register, watch, errors, smsMessage}) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="general-settings">{t("SMSEnable")}</div>
      <div className="add-numbermain">
        <div className="tel-numbers">
          {t("SMSEnable")}
          <br />
          <span className="phrecording">{smsMessage}</span>
        </div>

        <div className="phoneselect ">
          <label className="switch">
            <input className="form-control" type="checkbox" {...register("is_sms")}/>
            <span className="slider round"></span>
          </label>
        </div>
      </div>
    </>
  );
}

export default PhoneNumberSMSEnable;
